import dynamic from "next/dynamic";

export const ContentSideButtons = dynamic(() => import("./component"));
